// Extracted verbatim from CertifyPro_Prototype.zip js/translations.js
// Every key preserved exactly as in the approved prototype. Do not rename or remove keys.
const translations = {
  en: {
    // Platform
    platformName: "One Click School Solutions",
    platformTagline: "School Certificate Management Platform",
    // Nav
    dashboard: "Dashboard",
    students: "Students",
    certificates: "Certificates",
    schools: "Schools",
    employees: "Employees",
    settings: "Settings",
    logout: "Logout",
    // Login
    login: "Login",
    loginId: "Login ID",
    email: "Email Address",
    password: "Password",
    username: "Username",
    rememberMe: "Remember me",
    forgotPassword: "Forgot Password?",
    showPassword: "Show Password",
    superAdminLogin: "Super Admin Login",
    schoolAdminLogin: "School Admin Login",
    distributorLogin: "Distributor Login",
    loginBtn: "Sign In",
    // Dashboard cards
    totalRevenue: "Total Revenue",
    totalSchools: "Total Schools",
    totalLC: "Leaving Certificates",
    totalBonafide: "Bonafide Certificates",
    totalIDCards: "Student ID Cards",
    monthRevenue: "This Month Revenue",
    totalStudents: "Total Students",
    schoolsAdded: "Schools Added",
    commissionEarned: "Commission Earned",
    revenueGenerated: "Revenue Generated",
    // Students
    addStudent: "Add Student",
    importExcel: "Import Excel",
    exportExcel: "Export Excel",
    search: "Search...",
    filterStandard: "Filter by Standard",
    filterDivision: "Filter by Division",
    registerNumber: "Register Number",
    studentName: "Student Name",
    gender: "Gender",
    standard: "Standard",
    division: "Division",
    actions: "Actions",
    view: "View",
    edit: "Edit",
    delete: "Delete",
    // Student form
    studentIdentity: "Student Identity",
    serialId: "Serial ID",
    fullName: "Full Name",
    motherName: "Mother's Name",
    aadhaarNumber: "Aadhaar Number",
    personalDetails: "Personal Details",
    nationality: "Nationality",
    motherTongue: "Mother Tongue",
    religion: "Religion",
    caste: "Caste",
    subCaste: "Sub-Caste",
    birthInfo: "Birth Information",
    birthVillage: "Birth Village",
    birthTaluka: "Birth Taluka",
    birthDistrict: "Birth District",
    birthState: "Birth State",
    birthCountry: "Birth Country",
    dateOfBirth: "Date of Birth",
    dobInWords: "Date of Birth in Words",
    academicInfo: "Academic Information",
    previousSchool: "Previous School",
    previousStandard: "Previous Standard",
    admissionStandard: "Admission Standard",
    admissionDate: "Admission Date",
    save: "Save",
    update: "Update",
    deleteBtn: "Delete",
    clear: "Clear",
    cancel: "Cancel",
    // Certificates
    leavingCertificate: "Leaving Certificate",
    bonafideCertificate: "Bonafide Certificate",
    studentIDCard: "Student ID Card",
    generate: "Generate",
    preview: "Preview",
    print: "Print",
    downloadPDF: "Download PDF",
    saveDraft: "Save Draft",
    leavingDate: "Leaving Date",
    reason: "Reason for Leaving",
    conduct: "Conduct",
    lastAttendance: "Last Attendance Date",
    academicProgress: "Academic Progress",
    remarks: "Remarks",
    purpose: "Purpose",
    issueDate: "Issue Date",
    validityDate: "Validity Date",
    emergencyContact: "Emergency Contact",
    // School Info
    schoolInfo: "School Information",
    udiseNumber: "U-DISE Number",
    schoolName: "School Name",
    schoolVillage: "School Village Name",
    phone: "Phone Number",
    website: "Website",
    centre: "Centre",
    beat: "Beat",
    taluka: "Taluka",
    district: "District",
    pinCode: "PIN Code",
    lowestClass: "Lowest Class",
    highestClass: "Highest Class",
    medium: "Medium",
    grantType: "Grant Type",
    recognitionNumber: "Recognition Number",
    schoolCode: "School Code",
    boardName: "Board Name",
    boardAffiliationNumber: "Board Affiliation Number",
    managementType: "Management Type",
    // Status
    status: "Status",
    active: "Active",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    // Misc
    city: "City",
    contact: "Contact",
    commission: "Commission %",
    approve: "Approve",
    reject: "Reject",
    requestedSchools: "Requested Schools",
    recentSchools: "Recent Schools",
    recentStudents: "Recent Students",
    addSchool: "Add School",
    schoolAdmin: "School Admin",
    distributor: "Distributor",
    mobile: "Mobile",
    address: "Address",
    profilePicture: "Profile Picture",
    changePassword: "Change Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    // Payment
    paymentModal: "Payment Details",
    certificateType: "Certificate Type",
    price: "Price",
    taxes: "Taxes (GST 18%)",
    total: "Total Amount",
    proceedPayment: "Proceed to Payment",
    paymentSuccess: "Payment Successful!",
    paymentSuccessMsg: "Your certificate is ready to download.",
    expiresIn: "Download expires in",
    days: "days",
    // Notifications
    saved: "Saved successfully!",
    updated: "Updated successfully!",
    deleted: "Deleted successfully!",
    generated: "Certificate generated!",
    importSuccess: "Records imported successfully!",
    // Table empty states
    noData: "No records found",
    noStudents: "No students added yet",
    noSchools: "No schools found",
    // Misc UI
    language: "Language",
    notifications: "Notifications",
    profile: "My Profile",
    searchPlaceholder: "Search here...",
    allStandards: "All Standards",
    allDivisions: "All Divisions",
    male: "Male",
    female: "Female",
    other: "Other",
    currentStandard: "Current Standard",
    academicYear: "Academic Year",
    yes: "Yes",
    no: "No",
    selectStudent: "Select Student",
    autoFilled: "Auto-filled from student record",
  },
  mr: {
    platformName: "One Click School Solutions",
    platformTagline: "शाळा प्रमाणपत्र व्यवस्थापन प्रणाली",
    dashboard: "डॅशबोर्ड",
    students: "विद्यार्थी",
    certificates: "प्रमाणपत्रे",
    schools: "शाळा",
    employees: "कर्मचारी",
    settings: "सेटिंग्ज",
    logout: "लॉगआउट",
    login: "लॉगिन",
    loginId: "लॉगिन आयडी",
    email: "ईमेल पत्ता",
    password: "पासवर्ड",
    username: "वापरकर्ता नाव",
    rememberMe: "मला लक्षात ठेवा",
    forgotPassword: "पासवर्ड विसरलात?",
    showPassword: "पासवर्ड दाखवा",
    superAdminLogin: "सुपर अॅडमिन लॉगिन",
    schoolAdminLogin: "शाळा अॅडमिन लॉगिन",
    distributorLogin: "वितरक लॉगिन",
    loginBtn: "साइन इन करा",
    totalRevenue: "एकूण महसूल",
    totalSchools: "एकूण शाळा",
    totalLC: "शाळा सोडल्याचे दाखले",
    totalBonafide: "बोनाफाईड प्रमाणपत्रे",
    totalIDCards: "विद्यार्थी ओळखपत्रे",
    monthRevenue: "या महिन्याचा महसूल",
    totalStudents: "एकूण विद्यार्थी",
    schoolsAdded: "जोडलेल्या शाळा",
    commissionEarned: "मिळालेले कमिशन",
    revenueGenerated: "निर्माण झालेला महसूल",
    addStudent: "विद्यार्थी जोडा",
    importExcel: "एक्सेल आयात करा",
    exportExcel: "एक्सेल निर्यात करा",
    search: "शोधा...",
    filterStandard: "इयत्तेनुसार फिल्टर",
    filterDivision: "तुकडीनुसार फिल्टर",
    registerNumber: "नोंदणी क्रमांक",
    studentName: "विद्यार्थ्याचे नाव",
    gender: "लिंग",
    standard: "इयत्ता",
    division: "तुकडी",
    actions: "कृती",
    view: "पहा",
    edit: "संपादित करा",
    delete: "हटवा",
    studentIdentity: "विद्यार्थी ओळख",
    serialId: "अनुक्रमांक",
    fullName: "पूर्ण नाव",
    motherName: "आईचे नाव",
    aadhaarNumber: "आधार क्रमांक",
    personalDetails: "वैयक्तिक तपशील",
    nationality: "राष्ट्रीयत्व",
    motherTongue: "मातृभाषा",
    religion: "धर्म",
    caste: "जात",
    subCaste: "पोटजात",
    birthInfo: "जन्म माहिती",
    birthVillage: "जन्म गाव",
    birthTaluka: "जन्म तालुका",
    birthDistrict: "जन्म जिल्हा",
    birthState: "जन्म राज्य",
    birthCountry: "जन्म देश",
    dateOfBirth: "जन्मतारीख",
    dobInWords: "शब्दांत जन्मतारीख",
    academicInfo: "शैक्षणिक माहिती",
    previousSchool: "मागील शाळा",
    previousStandard: "मागील इयत्ता",
    admissionStandard: "प्रवेश इयत्ता",
    admissionDate: "प्रवेश तारीख",
    save: "जतन करा",
    update: "अद्यतनित करा",
    deleteBtn: "हटवा",
    clear: "साफ करा",
    cancel: "रद्द करा",
    leavingCertificate: "शाळा सोडल्याचा दाखला",
    bonafideCertificate: "बोनाफाईड प्रमाणपत्र",
    studentIDCard: "विद्यार्थी ओळखपत्र",
    generate: "तयार करा",
    preview: "पूर्वावलोकन",
    print: "छापा",
    downloadPDF: "PDF डाउनलोड करा",
    saveDraft: "मसुदा जतन करा",
    leavingDate: "शाळा सोडण्याची तारीख",
    reason: "शाळा सोडण्याचे कारण",
    conduct: "वर्तणूक",
    lastAttendance: "अंतिम उपस्थिती तारीख",
    academicProgress: "शैक्षणिक प्रगती",
    remarks: "शेरा",
    purpose: "उद्देश",
    issueDate: "दिनांक",
    validityDate: "वैधता तारीख",
    emergencyContact: "आपत्कालीन संपर्क",
    schoolInfo: "शाळेची माहिती",
    udiseNumber: "यू-डायस क्रमांक",
    schoolName: "शाळेचे नाव",
    schoolVillage: "शाळेचे गाव",
    phone: "दूरध्वनी क्रमांक",
    website: "वेबसाइट",
    centre: "केंद्र",
    beat: "बीट",
    taluka: "तालुका",
    district: "जिल्हा",
    pinCode: "पिन कोड",
    lowestClass: "सर्वात कमी इयत्ता",
    highestClass: "सर्वात जास्त इयत्ता",
    medium: "माध्यम",
    grantType: "अनुदान प्रकार",
    recognitionNumber: "मान्यता क्रमांक",
    schoolCode: "शाळा कोड",
    boardName: "बोर्डाचे नाव",
    boardAffiliationNumber: "बोर्ड संलग्नता क्रमांक",
    managementType: "व्यवस्थापन प्रकार",
    status: "स्थिती",
    active: "सक्रिय",
    pending: "प्रलंबित",
    approved: "मंजूर",
    rejected: "नाकारले",
    city: "शहर",
    contact: "संपर्क",
    commission: "कमिशन %",
    approve: "मंजूर करा",
    reject: "नाकारा",
    requestedSchools: "विनंती केलेल्या शाळा",
    recentSchools: "अलीकडील शाळा",
    recentStudents: "अलीकडील विद्यार्थी",
    addSchool: "शाळा जोडा",
    schoolAdmin: "शाळा अॅडमिन",
    distributor: "वितरक",
    mobile: "मोबाइल",
    address: "पत्ता",
    profilePicture: "प्रोफाईल चित्र",
    changePassword: "पासवर्ड बदला",
    newPassword: "नवीन पासवर्ड",
    confirmPassword: "पासवर्ड पुष्टी करा",
    paymentModal: "पेमेंट तपशील",
    certificateType: "प्रमाणपत्र प्रकार",
    price: "किंमत",
    taxes: "कर (GST 18%)",
    total: "एकूण रक्कम",
    proceedPayment: "पेमेंट करा",
    paymentSuccess: "पेमेंट यशस्वी!",
    paymentSuccessMsg: "तुमचे प्रमाणपत्र डाउनलोड करण्यासाठी तयार आहे.",
    expiresIn: "डाउनलोड कालावधी",
    days: "दिवस",
    saved: "यशस्वीपणे जतन केले!",
    updated: "यशस्वीपणे अद्यतनित केले!",
    deleted: "यशस्वीपणे हटवले!",
    generated: "प्रमाणपत्र तयार झाले!",
    importSuccess: "नोंदी यशस्वीपणे आयात केल्या!",
    noData: "कोणताही डेटा आढळला नाही",
    noStudents: "अद्याप कोणताही विद्यार्थी जोडलेला नाही",
    noSchools: "कोणतीही शाळा आढळली नाही",
    language: "भाषा",
    notifications: "सूचना",
    profile: "माझी प्रोफाईल",
    searchPlaceholder: "इथे शोधा...",
    allStandards: "सर्व इयत्ता",
    allDivisions: "सर्व तुकड्या",
    male: "पुरुष",
    female: "महिला",
    other: "इतर",
    currentStandard: "सद्य इयत्ता",
    academicYear: "शैक्षणिक वर्ष",
    yes: "होय",
    no: "नाही",
    selectStudent: "विद्यार्थी निवडा",
    autoFilled: "विद्यार्थी नोंदीतून स्वयं-भरले",
  },
  hi: {
    platformName: "One Click School Solutions",
    platformTagline: "स्कूल प्रमाणपत्र प्रबंधन प्लेटफॉर्म",
    dashboard: "डैशबोर्ड",
    students: "छात्र",
    certificates: "प्रमाणपत्र",
    schools: "स्कूल",
    employees: "कर्मचारी",
    settings: "सेटिंग्स",
    logout: "लॉगआउट",
    login: "लॉगिन",
    loginId: "लॉगिन आईडी",
    email: "ईमेल पता",
    password: "पासवर्ड",
    username: "उपयोगकर्ता नाम",
    rememberMe: "मुझे याद रखें",
    forgotPassword: "पासवर्ड भूल गए?",
    showPassword: "पासवर्ड दिखाएं",
    superAdminLogin: "सुपर एडमिन लॉगिन",
    schoolAdminLogin: "स्कूल एडमिन लॉगिन",
    distributorLogin: "वितरक लॉगिन",
    loginBtn: "साइन इन करें",
    totalRevenue: "कुल राजस्व",
    totalSchools: "कुल स्कूल",
    totalLC: "स्कूल छोड़ने के प्रमाणपत्र",
    totalBonafide: "बोनाफाइड प्रमाणपत्र",
    totalIDCards: "छात्र पहचान पत्र",
    monthRevenue: "इस महीने का राजस्व",
    totalStudents: "कुल छात्र",
    schoolsAdded: "जोड़े गए स्कूल",
    commissionEarned: "अर्जित कमीशन",
    revenueGenerated: "उत्पन्न राजस्व",
    addStudent: "छात्र जोड़ें",
    importExcel: "एक्सेल आयात करें",
    exportExcel: "एक्सेल निर्यात करें",
    search: "खोजें...",
    filterStandard: "कक्षा से फ़िल्टर करें",
    filterDivision: "विभाग से फ़िल्टर करें",
    registerNumber: "पंजीकरण संख्या",
    studentName: "छात्र का नाम",
    gender: "लिंग",
    standard: "कक्षा",
    division: "विभाग",
    actions: "क्रियाएं",
    view: "देखें",
    edit: "संपादित करें",
    delete: "हटाएं",
    studentIdentity: "छात्र पहचान",
    serialId: "क्रम संख्या",
    fullName: "पूरा नाम",
    motherName: "माता का नाम",
    aadhaarNumber: "आधार संख्या",
    personalDetails: "व्यक्तिगत विवरण",
    nationality: "राष्ट्रीयता",
    motherTongue: "मातृभाषा",
    religion: "धर्म",
    caste: "जाति",
    subCaste: "उपजाति",
    birthInfo: "जन्म जानकारी",
    birthVillage: "जन्म गांव",
    birthTaluka: "जन्म तालुका",
    birthDistrict: "जन्म जिला",
    birthState: "जन्म राज्य",
    birthCountry: "जन्म देश",
    dateOfBirth: "जन्मतिथि",
    dobInWords: "शब्दों में जन्मतिथि",
    academicInfo: "शैक्षणिक जानकारी",
    previousSchool: "पिछला स्कूल",
    previousStandard: "पिछली कक्षा",
    admissionStandard: "प्रवेश कक्षा",
    admissionDate: "प्रवेश तिथि",
    save: "सहेजें",
    update: "अपडेट करें",
    deleteBtn: "हटाएं",
    clear: "साफ करें",
    cancel: "रद्द करें",
    leavingCertificate: "स्कूल छोड़ने का प्रमाणपत्र",
    bonafideCertificate: "बोनाफाइड प्रमाणपत्र",
    studentIDCard: "छात्र पहचान पत्र",
    generate: "तैयार करें",
    preview: "पूर्वावलोकन",
    print: "प्रिंट करें",
    downloadPDF: "PDF डाउनलोड करें",
    saveDraft: "मसौदा सहेजें",
    leavingDate: "स्कूल छोड़ने की तिथि",
    reason: "स्कूल छोड़ने का कारण",
    conduct: "आचरण",
    lastAttendance: "अंतिम उपस्थिति तिथि",
    academicProgress: "शैक्षणिक प्रगति",
    remarks: "टिप्पणी",
    purpose: "उद्देश्य",
    issueDate: "जारी तिथि",
    validityDate: "वैधता तिथि",
    emergencyContact: "आपातकालीन संपर्क",
    schoolInfo: "स्कूल जानकारी",
    udiseNumber: "यू-डायस नंबर",
    schoolName: "स्कूल का नाम",
    schoolVillage: "स्कूल गांव",
    phone: "फोन नंबर",
    website: "वेबसाइट",
    centre: "केंद्र",
    beat: "बीट",
    taluka: "तालुका",
    district: "जिला",
    pinCode: "पिन कोड",
    lowestClass: "न्यूनतम कक्षा",
    highestClass: "उच्चतम कक्षा",
    medium: "माध्यम",
    grantType: "अनुदान प्रकार",
    recognitionNumber: "मान्यता संख्या",
    schoolCode: "स्कूल कोड",
    boardName: "बोर्ड का नाम",
    boardAffiliationNumber: "बोर्ड संबद्धता संख्या",
    managementType: "प्रबंधन प्रकार",
    status: "स्थिति",
    active: "सक्रिय",
    pending: "लंबित",
    approved: "स्वीकृत",
    rejected: "अस्वीकृत",
    city: "शहर",
    contact: "संपर्क",
    commission: "कमीशन %",
    approve: "स्वीकृत करें",
    reject: "अस्वीकृत करें",
    requestedSchools: "अनुरोधित स्कूल",
    recentSchools: "हाल के स्कूल",
    recentStudents: "हाल के छात्र",
    addSchool: "स्कूल जोड़ें",
    schoolAdmin: "स्कूल एडमिन",
    distributor: "वितरक",
    mobile: "मोबाइल",
    address: "पता",
    profilePicture: "प्रोफ़ाइल चित्र",
    changePassword: "पासवर्ड बदलें",
    newPassword: "नया पासवर्ड",
    confirmPassword: "पासवर्ड की पुष्टि करें",
    paymentModal: "भुगतान विवरण",
    certificateType: "प्रमाणपत्र प्रकार",
    price: "मूल्य",
    taxes: "कर (GST 18%)",
    total: "कुल राशि",
    proceedPayment: "भुगतान करें",
    paymentSuccess: "भुगतान सफल!",
    paymentSuccessMsg: "आपका प्रमाणपत्र डाउनलोड के लिए तैयार है।",
    expiresIn: "डाउनलोड समाप्त",
    days: "दिनों में",
    saved: "सफलतापूर्वक सहेजा गया!",
    updated: "सफलतापूर्वक अपडेट किया गया!",
    deleted: "सफलतापूर्वक हटाया गया!",
    generated: "प्रमाणपत्र तैयार हो गया!",
    importSuccess: "रिकॉर्ड सफलतापूर्वक आयात किए गए!",
    noData: "कोई रिकॉर्ड नहीं मिला",
    noStudents: "अभी तक कोई छात्र नहीं जोड़ा गया",
    noSchools: "कोई स्कूल नहीं मिला",
    language: "भाषा",
    notifications: "सूचनाएं",
    profile: "मेरी प्रोफ़ाइल",
    searchPlaceholder: "यहां खोजें...",
    allStandards: "सभी कक्षाएं",
    allDivisions: "सभी विभाग",
    male: "पुरुष",
    female: "महिला",
    other: "अन्य",
    currentStandard: "वर्तमान कक्षा",
    academicYear: "शैक्षणिक वर्ष",
    yes: "हाँ",
    no: "नहीं",
    selectStudent: "छात्र चुनें",
    autoFilled: "छात्र रिकॉर्ड से स्वतः भरा गया",
  }
};

export default translations;
